<template>
  <v-toolbar-items class="justify-center w-15 m-l-10" :id="attacheId">
    <v-menu class="g-language-select"
            transition="slide-y-transition"
            offset-y
            ref="langDropDown"
            :attach="'#' + attacheId"
            :nudge-right="-offsetLeft"
    >
      <v-flex slot="activator"
              ref="langFlag"
              class="d-flex justify-center align-center pb-2 pt-2">
        <i :class="langIcon"></i>
        <i class="icon-angle-down-18 ml-2"></i>
      </v-flex>
      <v-list>
        <v-list-tile
          v-for="(language, index) in languages"
          :key="index"
          @click="setLang(language)">
          <v-list-tile-title>{{ language.name }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '../../event-bus'

export default {
  name: 'Language',
  props: {
    attacheId: {
      default: '',
      required: false
    }
  },
  data () {
    return {
      offsetLeft: null,
      openLangDropDown: false
    }
  },
  watch: {
    langBarMobile: {
      handler (val) {
        if (this.$refs.langDropDown) {
          this.offsetLeft = this.$refs.langDropDown.$el.getBoundingClientRect().width / 2
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      languages: state => state.common.languages,
      langBarMobile: state => state.sidebar.sidebarIsOpen
    }),
    langIcon () {
      const activeLanguage = this.$store.getters['common/getActiveLanguage']
      if (activeLanguage && activeLanguage.code) {
        return 'g-language-' + activeLanguage.code
      } else {
        return 'g-language-en'
      }
    }
  },
  mounted () {
    this.offsetLeft = this.$refs.langDropDown && this.$refs.langDropDown.$el.getBoundingClientRect().width
  },
  methods: {
    setLang (lang) {
      this.$store.dispatch('common/setLang', lang.code).then(() => {
        // this.langIcon = 'g-language-' + lang.code
        (lang.code === 'hy') ? this.$moment.locale('hy-am') : this.$moment.locale('en')
        EventBus.$emit('language-changed', lang)
      }).catch(console.error)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/global/Language.vue